import { render, staticRenderFns } from "./SocialReplyModal.vue?vue&type=template&id=6cb98b08&"
import script from "./SocialReplyModal.vue?vue&type=script&lang=js&"
export * from "./SocialReplyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports